export const SORTABLE_INITIAL_STATE = {
    isOpen: false,
    data: [] as any[],
};

export const BULK_SELECTION_INITIAL_STATE = {
    isOpen: false,
    data: [] as number[],
};

export const INVOICE_TABLE_ALIAS = 'cp_invoice';
export const POD_TABLE_ALIAS = 'cp_pod';

// "Days Outstanding" filter buckets — days PAST DUE on unpaid invoices. Same values as WAL's
// Receivables DAYS_OVERDUE_BUCKET_OPTIONS so both apps read the same aging the same way.
export const DAYS_OVERDUE_BUCKET_OPTIONS = [
    { label: '1-30 days', value: '1-30' },
    { label: '31-60 days', value: '31-60' },
    { label: '61-90 days', value: '61-90' },
    { label: '90+ days', value: '90+' },
];

export const INVOICE_DEFAULT_COLUMNS = [
    // Renders as a "View Invoice" link (client request 2026-09-15) — the invoice number itself
    // is shown in the link tooltip and in the modal title.
    { id: 'invoiceNumber', name: 'Invoice', visible: true, displayOrder: 1 },
    { id: 'orderId', name: 'Order ID', visible: true, displayOrder: 2 },
    { id: 'status', name: 'Status', visible: true, displayOrder: 4 },
    { id: 'dueDate', name: 'Due Date', visible: true, displayOrder: 5 },
    { id: 'dateInvoiced', name: 'Date Invoiced', visible: true, displayOrder: 6 },
    { id: 'lastUpdated', name: 'Last Updated', visible: true, displayOrder: 7 },
    { id: 'totalPrice', name: 'Total Price', visible: true, displayOrder: 8 },
    { id: 'paymentTerms', name: 'Payment Terms', visible: true, displayOrder: 9 },
    // Days Pending column hidden per request — restore by uncommenting this line AND
    // removing the daysPending filter in AppLayout's setInvoiceColumns merge.
    // { id: 'daysPending', name: 'Days Pending', visible: true, displayOrder: 10 },
    { id: 'pod', name: 'POD', visible: true, displayOrder: 10 },
    // Newest upload date across the row's visible PODs — sits beside POD so the two read together.
    { id: 'podUploadedAt', name: 'POD Upload Date', visible: true, displayOrder: 11 },
    // No trailing action column: the per-row Download icon was removed (client request 2026-09-16).
];

export const POD_DEFAULT_COLUMNS = [
    { id: 'fileName', name: 'File Name', visible: true, displayOrder: 1 },
    { id: 'orderId', name: 'Order ID', visible: true, displayOrder: 2 },
    // Order-derived columns — same values (and same cell rendering) as the Orders listing.
    { id: 'origin', name: 'Origin', visible: true, displayOrder: 3 },
    { id: 'destination', name: 'Destination', visible: true, displayOrder: 4 },
    { id: 'deliveryDate', name: 'Delivery Date', visible: true, displayOrder: 5 },
    { id: 'carrier', name: 'Carrier', visible: true, displayOrder: 6 },
    { id: 'dateUploaded', name: 'Last Updated', visible: true, displayOrder: 7 },
    { id: 'action', name: '', visible: true, displayOrder: 8 },
];

export const INVOICE_COLUMN_CLASSNAME_MAP: Record<string, string> = {
    invoiceNumber: 'max-w-[150px] min-w-[150px]',
    orderId: 'max-w-[150px] min-w-[150px]',
    status: 'max-w-[150px] min-w-[150px]',
    dueDate: 'max-w-[160px] min-w-[160px]',
    dateInvoiced: 'max-w-[150px] min-w-[150px]',
    lastUpdated: 'max-w-[150px] min-w-[150px]',
    totalPrice: 'max-w-[150px] min-w-[150px]',
    paymentTerms: 'max-w-[150px] min-w-[150px]',
    daysPending: 'max-w-[150px] min-w-[150px]',
    pod: 'min-w-[150px] max-w-[150px]',
    podUploadedAt: 'max-w-[160px] min-w-[160px]',
    action: 'w-[40px] min-w-[40px] max-w-[40px] sticky right-0 bg-inherit',
};

export const INVOICE_COLUMN_TRANSLATION_MAP: Record<string, string> = {
    invoiceNumber: 'DocumentHub.Invoice',
    orderId: 'Common.Order_ID',
    status: 'Common.Status',
    dueDate: 'DocumentHub.Due_Date',
    dateInvoiced: 'DocumentHub.Date_Invoiced',
    lastUpdated: 'DocumentHub.Last_Updated',
    totalPrice: 'DocumentHub.Total_Price',
    paymentTerms: 'DocumentHub.Payment_Terms',
    daysPending: 'DocumentHub.Days_Pending',
    pod: 'DocumentHub.POD',
    podUploadedAt: 'DocumentHub.POD_Upload_Date',
    action: '',
};
